var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('span',[(_vm.additionalLogo)?_c('img',{staticClass:"C-header__logo--additional",attrs:{"src":_vm.additionalLogo,"width":"22","height":"26"}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }